module.exports = "/_next/static/images/21df3c26e8f69d9c70f46060411be61e-hands-holding-cards-lg@2x.jpg";